import { render, staticRenderFns } from "./StringFormatter.Split.vue?vue&type=template&id=c4991ad8&scoped=true"
import script from "./StringFormatter.Split.vue?vue&type=script&lang=js"
export * from "./StringFormatter.Split.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.Split.vue?vue&type=style&index=0&id=c4991ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4991ad8",
  null
  
)

export default component.exports